var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4829 24H6.48072C4.53037 24 2.75148 22.4737 2.42999 20.5115L1.00475 11.8341C0.779712 10.4823 1.42269 8.74901 2.48359 7.88781L9.90992 1.83753C11.3459 0.660189 13.607 0.671101 15.0537 1.84844L22.48 7.88781C23.5302 8.74901 24.1732 10.4823 23.9589 11.8341L22.5336 20.5115C22.2121 22.441 20.4011 24 18.4829 24ZM12.4711 2.61148C11.9031 2.61148 11.3352 2.786 10.9172 3.12394L3.49089 9.17408C2.88006 9.67554 2.46214 10.7876 2.59073 11.5725L4.016 20.2498C4.2089 21.3945 5.33408 22.3648 6.48072 22.3648H18.4829C19.6295 22.3648 20.7547 21.3945 20.9476 20.2389L22.3729 11.5615C22.5015 10.7766 22.0728 9.65373 21.4727 9.16317L14.0464 3.12394C13.6177 2.786 13.0498 2.61148 12.4711 2.61148Z",
    fill: "#091F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a515fbfaaf0a23dbbd375dd759a49d25.svg";
export { ForwardRef as ReactComponent };